const DashboardDiscriminator = Object.freeze({
  DASHBOARD: 'DASHBOARD',
  ANALYSIS: 'ANALYSIS'
})
export default DashboardDiscriminator
// RESERVE BELOW
